(() => {
  if (!customElements.get("product-card-swatches")) {
    class ProductCardSwatches extends HTMLElement {
      constructor() {
        super();

        const jsonData = this.querySelector("script").innerText;
        this.optionsArrays = JSON.parse(jsonData);

        this.buildSwatches();
      }

      buildSwatches() {
        const swatches = window.swatches;

        const swatchesArrays = this.optionsArrays.map((valuesArray) => {
          return valuesArray
            .map((value) => {
              const swatch = swatches.find(
                (swatch) => swatch.handle === value.handle
              );
              return swatch ? { ...value, color: swatch.color } : null;
            })
            .filter((value) => value);
        });

        const maxArray = swatchesArrays.reduce((a, b) =>
          a.length > b.length ? a : b
        );
        if (maxArray.length === 0) return this.remove();
        if (!maxArray.some((value) => value.selected)) {
          maxArray[0].selected = true;
        }

        const html = maxArray
          .map((value) => {
            const isWhite = value.color === "#ffffff" || value.color === "#fff";

            let classes = "product-card-swatches__item";
            if (value.selected)
              classes += " product-card-swatches__item--selected";
            if (isWhite) classes += " product-card-swatches__item--white";

            return `
            <a href="${value.url}" class="${classes}" style="--background-color: ${value.color};"></a>
          `;
          })
          .join("");

        this.innerHTML = html;
      }
    }
    customElements.define("product-card-swatches", ProductCardSwatches);
  }
})();
